import { FC } from "react";
import { Asset, Entry } from "contentful";
import styled from "styled-components";

const SubMainLink = styled.a`
  border-bottom: 1px solid #eaeaea;
  color: #1a1b1b;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  line-height: 24px;
  padding-bottom: 24px;
  pointer-events: none;
  text-decoration: none;
  width: 100%;
`;

const PromoTileInfoLink = styled.div`
  color: #1a1b1b;
  font-size: 14px;
  font-style: normal;
  line-height: 38px;
  text-decoration: none;
`;

const Picture = styled.picture`
  display: flex;
`;

const Image = styled.img<{ $hide?: string; }>`
  width: 100%;

  ${({ $hide }) => $hide == 'small' && `
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  `}

  ${({ $hide }) => $hide == 'large' && `
    @media (min-width: 768px) {
      display: none;
    }
  `}
`;

interface ContentfulNavigationImageEntry extends Entry {
  fields: {
    altText: string;
    mainAsset: Asset;
    mobileAsset: Asset;
    textContent: string;
    title: string;
    url: string;
  }
}

const PromoSection: FC<ContentfulNavigationImageEntry> = ({fields: {
  altText,
  mainAsset,
  mobileAsset,
  textContent,
  title,
  url
}}) => (
  <>
    <SubMainLink href="#">{title}</SubMainLink>
    <a href={url}>
      <Picture>
        <Image
          alt={altText}
          $hide={mobileAsset ? 'small' : ''}
          src={`https:${mainAsset?.fields?.file?.url}`}
        />
        {mobileAsset && (
          <Image
            alt={altText}
            $hide="large"
            src={`https:${mobileAsset?.fields?.file?.url}`}
          />
        )}
      </Picture>
      <PromoTileInfoLink className="promotion-tiles__info__link">{textContent}</PromoTileInfoLink>
    </a>
  </>
);



export default PromoSection

